<template>
    <v-row>
      <v-col lg="12" md="12" v-if="user">
        <v-card class="card-shadow px-4 py-4 overflow-hidden border-radius-xl">
          <v-row>
            <v-col cols="auto">
              <v-avatar width="74" height="74" class="shadow border-radius-lg">
                <img
                  src="@/assets/img/user.jpg"
                  alt="Avatar"
                  class="border-radius-lg"
                />
              </v-avatar>
            </v-col>
            <v-col cols="auto" class="my-auto">
              <div class="h-100">
                <h5 class="mb-1 text-h5 text-typo font-weight-bold">
                  {{ user.firstName }}
                </h5>
                <p class="mb-0 font-weight-bold text-body text-sm">
                  {{ user.lastName }}
                </p>
              </div>
            </v-col>
          </v-row>
          <PaymentTable :user="user" v-bind="$attrs"></PaymentTable>
        </v-card>
      </v-col>
    </v-row>
</template>

<script>
import { mapState } from "vuex";
import { currentUser } from "@/firebaseConfig";
const fb = require("@/firebaseConfig.js");
export default {
  name: "StudentDetail",
  data: () => ({
    user: null,
  }),
  computed: {
    ...mapState(["userProfile", "currentUser"]),
  },
  components: {
    PaymentTable: () => import("@/views/students/PaymentTable"),
  },
  props: {
    studentPath: {
      type: String,
      required: true,
    },
    collectionpath: {
      type: String,
      required: true,
    },
  },
  created() {
    fb.db.doc(this.studentPath)
      .get()
      .then((doc) => {
        let user = doc.data();
        user.id = doc.id;
        user.ref = doc.ref;
        this.user = user;
      });
  },
  methods: {},
};
</script>
